import { render, staticRenderFns } from "./FSNsCompare.vue?vue&type=template&id=f936b468&scoped=true"
import script from "./FSNsCompare.vue?vue&type=script&lang=js"
export * from "./FSNsCompare.vue?vue&type=script&lang=js"
import style0 from "./FSNsCompare.vue?vue&type=style&index=0&id=f936b468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936b468",
  null
  
)

export default component.exports